import type { CustomContractDataFieldDto } from "../../autogen/bff-api";

const TEXT_SEARCHABLE_TYPES: CustomContractDataFieldDto["type"][] = [
  "CustomText",
  "CustomEmail",
  "CustomPhone",
  "CustomUrl",
  "CustomTag",
  "CustomEnum",
  "CustomRichText",
  "CustomMultiEnum",
];

export const isCustomFieldTextSearchable = (fieldType: CustomContractDataFieldDto["type"]): boolean =>
  TEXT_SEARCHABLE_TYPES.includes(fieldType);
